const PK_PLACEHOLDER = "000000";
const QUANTITY_LIMIT = 200;

export { PK_PLACEHOLDER, QUANTITY_LIMIT };
